import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar } = FiIcons;

const SocialProof = () => {
  const testimonials = [
    {
      name: "Sarah Jenkins",
      business: "Apex Roofing Specialists",
      text: "The audit showed us exactly why we were losing calls to a competitor who does worse work. We implemented the 30-day plan and saw a 40% increase in map pack visibility.",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop"
    },
    {
      name: "Dr. Michael Chen",
      business: "Chen Dental Group",
      text: "I was skeptical at first, but the insights were better than what my $2,000/mo SEO agency was giving me. Chris knows local trust inside and out.",
      image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=200&auto=format&fit=crop"
    },
    {
      name: "Marcus Thorne",
      business: "Thorne Premium HVAC",
      text: "We had no idea our AI search readiness was nonexistent. The scorecard made it incredibly simple to understand what we needed to fix first.",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=200&auto=format&fit=crop"
    }
  ];

  return (
    <section className="py-24 bg-navy-800 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">Trusted by Local Market Leaders</h2>
          <p className="text-xl text-slate-400">See what happens when you fix your trust gaps.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass-card rounded-2xl p-8 flex flex-col"
            >
              <div className="flex text-teal mb-6">
                {[...Array(5)].map((_, j) => <SafeIcon key={j} icon={FiStar} className="fill-current w-5 h-5" />)}
              </div>
              <p className="text-slate-300 text-lg leading-relaxed mb-8 flex-grow">"{t.text}"</p>
              
              <div className="flex items-center gap-4">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-teal/30" />
                <div>
                  <p className="text-white font-bold">{t.name}</p>
                  <p className="text-teal text-sm">{t.business}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;